import PropTypes from 'prop-types';

import SnackBars from '@app/components/SnackBars';
import WorkspaceAdminAlertModal from '@app/components/WorkspaceAdminConfirmModal';
import Authentication from '@app/containers/Authentication';
import GlobalNavigationBar from '@app/containers/GlobalNavigationBar';

const propTypes = {
  children: PropTypes.element.isRequired,
};

function MainLayout({ children }) {
  return (
    <Authentication>
      <GlobalNavigationBar />
      <SnackBars />
      <WorkspaceAdminAlertModal />
      {children}
    </Authentication>
  );
}

MainLayout.propTypes = propTypes;

export default MainLayout;
